export default __webpack_public_path__ + "static/media/elastic.b42e2ecf603367470e617b7613e8602f.svg";